import forEach from '../../../../javascripts/dom/forEach';

const stage75 = document.querySelectorAll('[data-js-module="o-stage-75"]');

const init = async () => {
  const { default: Stage75 } = await import(/* webpackChunkName: "o-stage75" */ './stage75');
  forEach(stage75, (index, element) => new Stage75(element));
};

if (stage75.length) init();
